import makeRequest from "services/makeRequest";
import { routes } from "routes/apiRoutes";
import {
  downloadFile,
  formatUrlQuery,
  isAdminUser,
  isAggregatorUser,
  isSuccessResponse,
  notFoundStatus,
  setAlert,
} from "utils/helper";
import {
  SET_TRANSACTION_TYPES,
  GET_TRANSACTION_DETAIL,
  GET_TRANSACTION_DETAIL_SUCCESS,
  GET_TRANSACTION_DETAIL_FAIL,
  SET_TRANSACTION_QUERY,
  GET_TRANSACTION_BREAKDOWN_SUCCESS,
  GET_TRANSACTION_BREAKDOWN_FAIL,
  GET_TRANSACTION_BREAKDOWN,
  SET_CURRENT_TRANSACTION,
  CLEAR_TRANSACTION_DETAIL,
  SET_SEARCHED_AGENT,
  RESET_SEARCHED_AGENT,
  DOWNLOAD_TRANSACTION_DETAIL,
  DOWNLOAD_TRANSACTION_DETAIL_COMPLETE,
} from "../types/transactionTypes";
import { getTerminalActivity } from "../actions/dashboard/terminalDashboardActions";

import store from "../store";

const { dispatch, getState } = store;

const getTerminalDetails = () => getState()?.transactionsReducer;

const getUser = () => getState()?.user?.user;

export const getTransactionTypes = async () => {
  dispatch({ type: SET_TRANSACTION_TYPES });
  try {
    const { data } = await makeRequest("get", routes.fetchTransactionTypes());

    if (isSuccessResponse(data)) {
      dispatch({
        type: SET_TRANSACTION_TYPES,
        payload: data?.data?.content,
      });
    }
  } catch (err) {
    console.log(err);
  }
};

export const getTransactionDetails = async (useQuery = true) => {
  dispatch({ type: GET_TRANSACTION_DETAIL });

  let queryParams = { ...getTerminalDetails().params };

  queryParams.type = queryParams.type.map((transaction) => transaction.value);

  queryParams.region = queryParams.region.map((region) => region.value);

  try {
    const { data } = await makeRequest(
      "get",
      routes.getTransactionDetails(
        formatUrlQuery(useQuery ? queryParams : { number: 1, size: 10 })
      )
    );
    if (isSuccessResponse(data)) {
      dispatch({
        type: GET_TRANSACTION_DETAIL_SUCCESS,
        payload: data.data,
      });
    } else {
      dispatch({
        type: GET_TRANSACTION_DETAIL_FAIL,
      });
    }
  } catch (error) {
    if (notFoundStatus(error)) {
      dispatch({
        type: GET_TRANSACTION_DETAIL_FAIL,
      });
    }
    console.log(error);
  }
};

export const downloadTransactionDetails = async () => {
  dispatch({ type: GET_TRANSACTION_DETAIL });

  let queryParams = { ...getTerminalDetails().params };

  queryParams.type = queryParams.type.map((transaction) => transaction.value);

  queryParams.region = queryParams.region.map((region) => region.value);

  dispatch({
    type: DOWNLOAD_TRANSACTION_DETAIL,
  });

  try {
    const { data } = await makeRequest(
      "get",
      routes.downloadTransactionDetails(formatUrlQuery(queryParams))
    );

    await downloadFile(
      data,
      `PocketMoni Transaction Report - ${Date.now()}`,
      "text/csv"
    );
    dispatch({
      type: DOWNLOAD_TRANSACTION_DETAIL_COMPLETE,
      payload: data.data,
    });
  } catch (error) {}
};

export const clearTransactionDetails = () => {
  dispatch({
    type: CLEAR_TRANSACTION_DETAIL,
  });
};

export const setTransactionQuery = (payload) => {
  dispatch({
    type: SET_TRANSACTION_QUERY,
    payload,
  });
};

export const getTransactionStatsBreakdown = async () => {
  dispatch({ type: GET_TRANSACTION_BREAKDOWN });

  const { terminalId, agentId, dateFrom, dateTo, type } =
    getTerminalDetails().params;

  const queryParams = {
    agentId,
    terminalId,
    type: type.map((transaction) => transaction.value),
    dateFrom,
    dateTo,
  };

  try {
    const { data } = await makeRequest(
      "get",
      routes.getTransactionStatsBreakdown(formatUrlQuery(queryParams))
    );
    if (isSuccessResponse(data)) {
      dispatch({
        type: GET_TRANSACTION_BREAKDOWN_SUCCESS,
        payload: data.data,
      });
    } else {
      dispatch({
        type: GET_TRANSACTION_BREAKDOWN_FAIL,
      });
    }
  } catch (error) {
    if (notFoundStatus(error)) {
      dispatch({
        type: GET_TRANSACTION_BREAKDOWN_FAIL,
      });
    }
    console.log(error);
  }
};

export const setCurrentTransaction = (payload) => {
  dispatch({ type: SET_CURRENT_TRANSACTION, payload });
};

export const getAllTransactionsData = async (cb) => {
  const { dateFrom, dateTo } = getTerminalDetails().params;

  // check for dates validity if any exists
  if (dateFrom || dateTo) {
    if ((dateFrom && !dateTo) || (dateTo && !dateFrom)) {
      return setAlert("Please select start and both dates");
    }

    if (dateFrom > dateTo) {
      return setAlert("Please select valid dates");
    }
  }

  await getTransactionDetails();
  await getTransactionStatsBreakdown();

  if (isAdminUser(getUser())) {
    // getTerminalActivity(agentId);
  }

  if (cb) cb();
};

export const setSearchedAgentValue = (payload) => {
  dispatch({
    type: SET_SEARCHED_AGENT,
    payload,
  });
};

export const searchAgent = async (searchValue) => {
  const user = getUser();

  let queryParams = {
    searchValue,
    size: 50,
  };

  //Add parentId to filters if user is an aggregator
  if (isAggregatorUser(user)) {
    queryParams = {
      ...queryParams,
      parentId: user?.agent_id,
      userType: "AGENT_USER",
    };
  }

  try {
    const { data } = await makeRequest(
      "get",
      routes.getAgentPersonalDetails(formatUrlQuery(queryParams))
    );

    if (data.data.content.length) {
      const agents = data?.data?.content;
      if (!agents.length) {
        return [];
      } else {
        return agents.map((agent) => ({
          label: `${agent.agentDetails.agentId} - ${agent.firstName} ${agent.lastName}`,
          value: agent.agentDetails.agentId,
        }));
      }
    } else {
    }
  } catch (err) {}
};

const resetSearchedAgent = () => {
  dispatch({
    type: RESET_SEARCHED_AGENT,
  });
};

//Only admin calls this endpoint
export const resetAllAgentQuery = () => {
  setTransactionQuery({
    name: "agentId",
    value: "",
  });
  getAllTransactionsData();
  resetSearchedAgent();
  getTerminalActivity();
};
